import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { resetState } from '../actions';
import { NotificationType, StateStatus } from '../core';
import { ARCHIVE_VIDEO, CREATE_VIDEO, getVideos, PROVIDER_VIDEOS, STATUS_VIDEO, UPDATE_VIDEO, VIDEO_DUPLICATE, VIDEO_REORDER } from '../new/video';
import { NOTIFICATION } from '../types';

import { useEffectOnSuccess } from '.';

const useVideos = (clearStateOnLeave = true) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.videos.all);
  const { create, update, archive, toggleStatus, reorder, duplicate } = useSelector(state => state.videos);

  useEffect(() => {
    if (status === StateStatus.LOADING) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getVideos());
    }
    if (create.version || archive.version || update.version || toggleStatus.version || reorder.version || duplicate.version) {
      dispatch(resetState(PROVIDER_VIDEOS));
      create.version && dispatch(resetState(CREATE_VIDEO));
      archive.version && dispatch(resetState(ARCHIVE_VIDEO));
      update.version && dispatch(resetState(UPDATE_VIDEO));
      toggleStatus.version && dispatch(resetState(STATUS_VIDEO));
      reorder.version && dispatch(resetState(VIDEO_REORDER));
      duplicate.version && dispatch(resetState(VIDEO_DUPLICATE));
    }
    if (!archive.status && archive.errors) {
      dispatch({ type: NOTIFICATION, payload: { message: t(`VALIDATIONS.${archive.errors[0].message}`), variant: NotificationType.Error } });
    }
  }, [
    archive.errors,
    archive.status,
    archive.version,
    create.version,
    dispatch,
    duplicate.version,
    reorder.version,
    status,
    t,
    toggleStatus.version,
    update.version,
  ]);

  useEffectOnSuccess([state => state.sections.addFile], () => {
    dispatch(getVideos(true));
  });

  useEffect(() => {
    return () => clearStateOnLeave && dispatch(resetState(PROVIDER_VIDEOS));
  }, [clearStateOnLeave, dispatch]);

  return { data: data || [], status, version, entity };
};

export default useVideos;
